import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { marcarTelasDeForaDesatualizadas, meuUsuarioId } from './acaoTriagem';
import { useToast } from '@/hooks/use-toast';

/** Registra a justificativa da fila. A coluna é carimbada pelo banco a partir
 *  do item — a tela não escolhe qual fila está justificando. */
export function useJustificativaFila() {
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const justificar = useMutation({
    mutationFn: async ({ itemId, pedidoId, justificativa, motivoCodigo, acaoCodigo }: {
      itemId: string; pedidoId: string; justificativa: string; motivoCodigo?: string | null; acaoCodigo?: string | null;
    }) => {
      if (justificativa.trim().length < 10) throw new Error('Escreva a justificativa: por que o item continua nesta fila.');
      const { error } = await supabase.from('fila_justificativas').insert({
        item_id: itemId, pedido_id: pedidoId, coluna: '', justificativa: justificativa.trim(), usuario_id: await meuUsuarioId(),
        motivo_codigo: motivoCodigo ?? null, acao_codigo: acaoCodigo ?? null,
      } as never);
      if (error) throw error;
    },
    onSuccess: () => {
      toast({ title: 'Justificativa registrada', description: 'Está na timeline do pedido, identificada pela fila.' });
      ['triagem-ativacao', 'triagem-nota-fiscal', 'portabilidade-extras', 'timeline-pedido-modal']
        .forEach(key => void queryClient.invalidateQueries({ queryKey: [key] }));
      marcarTelasDeForaDesatualizadas(queryClient);
    },
    onError: error => toast({ title: 'Não foi possível justificar', description: (error as { message?: string } | null)?.message || 'Tente novamente.', variant: 'destructive' }),
  });
  return { justificarAsync: justificar.mutateAsync, isJustificando: justificar.isPending };
}
